import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=2546bfc2&scoped=true&"
import script from "./ModuleEdit.vue?vue&type=script&lang=js&"
export * from "./ModuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModuleEdit.vue?vue&type=style&index=0&id=2546bfc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546bfc2",
  null
  
)

export default component.exports